export function englishPlural(singular: string): string {
  if (!singular) {
    return "";
  }
  const s = singular.toLocaleLowerCase("en");
  if (singular[0] !== s[0]) {
    if (singular === singular.toLocaleUpperCase("en")) {
      const plural = englishPlural(s);
      return plural.toLocaleUpperCase("en");
    } else {
      const plural = englishPlural(s);
      return plural[0].toUpperCase() + plural.substring(1);
    }
  }
  const irregularPlural = _irregularPlurals[s];
  if (irregularPlural) {
    return irregularPlural;
  }
  if (
    singular.endsWith("s") ||
    singular.endsWith("sh") ||
    singular.endsWith("ch") ||
    singular.endsWith("x") ||
    singular.endsWith("z")
  ) {
    return singular + "es";
  } else if (singular.match(new RegExp(`[${_consonants}]y$`, "g"))) {
    return singular.substring(0, singular.length - 1) + "ies";
  } else {
    return singular + "s";
  }
}

const _irregularPlurals: { [index: string]: string } = {
  man: "men",
  person: "people",
  woman: "women",
};

const _consonants = "bcdfghjklmnpqrstvxzw";
